'use strict';

var React = require('react');

var SvgExistingInventoryMajor = function SvgExistingInventoryMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 9c0 .55-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1zm-16-1h3v-5h-3v5zm-2 9h5v-7h-5v7zm14-2c-.55 0-1 .45-1 1v1h-6v-11h3c.55 0 1-.45 1-1s-.45-1-1-1h-3v-2c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1v6h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h15c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1z"
  }));
};

exports.SvgExistingInventoryMajor = SvgExistingInventoryMajor;
